import { render, staticRenderFns } from "./Food_Intro.vue?vue&type=template&id=229682aa&scoped=true&"
import script from "./Food_Intro.vue?vue&type=script&lang=js&"
export * from "./Food_Intro.vue?vue&type=script&lang=js&"
import style0 from "./Food_Intro.vue?vue&type=style&index=0&id=229682aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229682aa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VBtn,VContainer,VIcon,VSkeletonLoader})
